import Vue from "vue";

export class SMTP {
    static create() {
        return {
            username: null,
            password: null,
            host: null,
            ssl: true,
            port: 587
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("smtp/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("smtp/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("smtps")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("smtps", data);
            } else {
                promisse = Vue.http.post("smtps", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
